import {globalEmitter} from "@straylightagency/events";

export default class Loader {
    callbacks = {};
    items = {};
    loadedItems = [];
    max = 0;

    when(type, callback)
    {
        this.callbacks[ type ] = callback;

        return this;
    }

    push(type, asset, name = null)
    {
        if ( !this.items[ type ] ) {
            this.items[ type ] = [];
        }

        this.items[ type ].push( {
            name,
            asset
        } );
        this.max++;

        return this;
    }

    async handle({started, progress, finished})
    {
        let hasFinished = false;
        const loadableItems = this.items;
        const max = this.max;
        let count = 0;

        globalEmitter.dispatch( 'loader:started', {count, max}, this );

        if ( started ) {
            await started( {count, max} );
        }

        const _finished = async items => {
            if ( count === max ) {
                globalEmitter.dispatch( 'loader:finished', {count, max, items}, this );

                if ( finished ) {
                    await finished( {count, max, items} );
                }

                hasFinished = true;
            }
        };

        for (const [ type, items ] of Object.entries( loadableItems ) ) {
            const callback = this.callbacks[ type ] || ( ( item, loaded ) => loaded() );

            for ( const {name, asset} of items ) {
                const loaded = async asset => {
                    count++;

                    globalEmitter.dispatch( 'loader:progress', {count, max}, this );

                    if ( progress ) {
                        await progress( {count, max} );
                    }

                    this.loadedItems.push( {
                        name,
                        asset,
                    } );

                    await _finished( this.loadedItems );
                };

                callback.call( this, asset, loaded );
            }
        }

        if ( ! hasFinished ) {
            await _finished( this.loadedItems );
        }

        this.reset();
    }

    reset()
    {
        this.items = {};
        this.loadedItems = [];
        this.max = 0;

        return this;
    }
}